import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import InvoiceFilterBar, { InvoiceFilterKey } from 'components/invoices/InvoiceFilterBar';
import InvoicesTable, { InvoicesTableSearchFilters } from 'components/invoices/InvoicesTable';

const FILTERS: InvoiceFilterKey[] = [
  'search',
  'dueDateRange',
  'status',
  'productType',
  'autoPay',
  'paymentMethods',
];

const Invoices = (): JSX.Element => {
  const initialSearchFiltersValue: InvoicesTableSearchFilters = {
    search: '',
    status: [],
    autoPay: null,
    dueDateRange: [null, null],
    paymentMethods: [],
  };
  const [searchFilters, setSearchFilters] = useState<InvoicesTableSearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<InvoicesTableSearchFilters>(searchFilters, 250);
  const [orderingValue, setOrderingValue] = useState<string>('dueDate');

  return (
    <>
      <InvoiceFilterBar
        source='invoices'
        title='Invoices'
        filters={FILTERS}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
        orderingValue={orderingValue}
        csvReportType='invoices-export'
      />

      <InvoicesTable searchFilters={debouncedSearchFilters} setOrderingValue={setOrderingValue} />
    </>
  );
};

export default Invoices;
